import React from 'react';
import { NavLink } from 'react-router-dom';

const ContactsCrumb = () => <NavLink to="/core/contacts">Other Contacts</NavLink>;

export default ContactsCrumb;
